module.exports = __webpack_public_path__ + "media/images/flags/4x3/ssd-8b2f0948a0fdc4f59715c3bdcf2e653a.svg";